import React from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';

const HierarchyActionsMenu = ({ hierarchy, hierarchyActions, anchorEl, onClose }) => {
  const { t } = useTranslation();

  return (
    <Menu id='hierarchy-actions-menu' anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      {hierarchyActions.map((action, index) => {
        return (
          <MenuItem
            key={index}
            onClick={() => {
              action.effect(hierarchy);
              onClose();
            }}
          >
            {t(action.label)}
          </MenuItem>
        );
      })}
    </Menu>
  );
};

HierarchyActionsMenu.propTypes = {
  hierarchy: PropTypes.object.isRequired,
  hierarchyActions: PropTypes.array.isRequired,
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired
};

export default HierarchyActionsMenu;
